import { render, staticRenderFns } from "./InfoPasmoCharge.vue?vue&type=template&id=67246836&"
import script from "./InfoPasmoCharge.vue?vue&type=script&lang=ts&"
export * from "./InfoPasmoCharge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
